import { createModel } from "@/orm/model";
import { belongsToIds, BelongsToIds, EntityRecord } from "@/orm/types";
import { ContactDirectoryRecord } from "./contactDirectory";
import { DealRecord } from "./deal";
import { Note } from "./note";
import { getUserDefaultRecordId } from "./user";

export type ContactRecord = EntityRecord & {
  name: string;
  email: string;
  phone: string;
  website: string;
  firm: string;
  jobTitleIds: string[];
  location: string;
  remarks: string;
  notes: Note[] | null;
  belongsToContactDirectoryIds: BelongsToIds<ContactDirectoryRecord>;
  belongsToDealIds: BelongsToIds<DealRecord>;
};

export const contactModel = createModel<ContactRecord>({
  version: "1.0",
  collectionPath: "modelEntityRecordContact",
  labels: {
    singular: "Contact",
    plural: "Contacts",
  },
  getDefaultRecord: () => {
    return {
      name: "Untitled Contact " + new Date().toLocaleDateString(),
      email: "",
      phone: "",
      website: "",
      firm: "",
      jobTitleIds: [],
      location: "",
      remarks: "",
      notes: null,
      belongsToContactDirectoryIds: belongsToIds([getUserDefaultRecordId()]),
      belongsToDealIds: belongsToIds([]),
    };
  },
});

const getPathContactId = () => {
  return window.location.pathname.split("/contact/")[1].split("/")[0];
};

export const getCurrentContactEntity = () => {
  return contactModel.createEntityInstance({
    id: getPathContactId(),
  });
};
